module.exports = __webpack_public_path__ + "img/sso-default.61b11ce4.svg";